import { Plugin } from "@nuxt/types";
import { initializeMsal } from "~/utils/msal";

const accessor: Plugin = context => {
  initializeMsal(context.app.$msal);
};

export default accessor;
